export default __webpack_public_path__ + "img/mitra-icon-active.1449e8d4.svg";